const session = "supercook";
export default session;
